

let localhost="http://127.0.0.1:8080/huapin"
let test="https://admin.zhuzhux.com/huapin"
let prod="https://bcqx.zhuzhux.com/huapin"
let qinbin="https://qinbin.zhuzhux.com/huapin"

let env = {

    BASE_API: qinbin, // 开发环境


    
}
export default env


// WEBPACK FOOTER //
// ./src/services/env.js